import React from 'react'
import { MessageCircle, QrCode, Send, CheckCircle, Bitcoin, DollarSign } from 'lucide-react';
import PaymentStep from './PaymentStep';

export default function StepsPay() {
    const steps = [
        {
            title: "Zahlungswunsch mitteilen",
            description: "Sagen Sie uns einfach, dass Sie mit Bitcoin bezahlen möchten.",
            icon: <MessageCircle />
        },
        {
            title: "QR-Code erhalten",
            description: "Unser sicheres Zahlungssystem erstellt einen QR-Code mit dem fälligen Bitcoin-Betrag und unserer Wallet-Adresse.",
            icon: <QrCode />
        },
        {
            title: "Zahlung ausführen",
            description: "Sie haben nun 15 Minuten Zeit, den Betrag über Ihre Wallet zu senden - der angezeigte Wechselkurs bleibt in diesem Zeitraum garantiert.",
            icon: <Send />
        },
        {
            title: "Bestätigung & Abschluss",
            description: "Nach Eingang Ihrer Zahlung erhalten wir automatisch die Bestätigung - und Ihr Fahrzeugkauf ist abgeschlossen.",
            icon: <CheckCircle />
        }
    ];

    const cryptoIcons = [
        { name: 'Bitcoin', symbol: '₿', color: 'bg-orange-500' },
        { name: 'Ethereum', symbol: 'Ξ', color: 'bg-blue-500' },
        { name: 'USDC', symbol: '$', color: 'bg-green-500' },
        { name: 'Tether', symbol: '₮', color: 'bg-emerald-500' },
        { name: 'Polygon', symbol: '⬢', color: 'bg-purple-500' },
        { name: 'Dogecoin', symbol: 'Ð', color: 'bg-yellow-500' },
        { name: 'Solana', symbol: '◎', color: 'bg-pink-500' },
    ];
    return (
        <div className="min-h-screen bg-black text-white">
            <div className="max-w-6xl mx-auto px-4 py-20 sm:px-6 lg:px-8">
                {/* <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">
                        Mit Krypto bezahlen
                    </h2>
                    <p className="text-xl text-gray-300 mb-12">
                        Wir akzeptieren verschiedene Kryptowährungen
                    </p>

                    <div className="flex justify-center items-center space-x-4 mb-16 flex-wrap gap-4">
                        {cryptoIcons.map((crypto, index) => (
                            <div
                                key={index}
                                className={`${crypto.color} w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg hover:scale-110 transition-transform duration-200`}
                            >
                                {crypto.symbol}
                            </div>
                        ))}
                    </div>
                </div> */}
                <div className="text-center mb-8">
                    <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
                        Mit Bitcoin oder USDC Einfach und sicher zum Traumauto.
                    </h2>
                    <p className="text-gray-300 max-w-xl mx-auto">
                        Als Ihr kompetenter Partner rund um den Kauf und Verkauf von Fahrzeugen bieten wir Ihnen auch die Möglichkeit, mit Bitcoin, der weltweit führenden Kryptowährung oder der digitalen Währung USDC, zu bezahlen.
                        Bitcoin-Zahlung leicht gemacht
                        Sie möchten Ihr Fahrzeug mit Bitcoin bezahlen? Kein Problem!
                    </p>
                </div>

                {/* Steps Section */}
                <div className="p-8">
                    <div className="text-center mb-12">
                        <h3 className="text-3xl font-bold mb-4">So funktioniert's:</h3>
                        {/* <p className="text-gray-400 text-lg">
                            Sie möchten Ihr Fahrzeug mit Bitcoin bezahlen? Kein Problem!
                        </p> */}
                    </div>

                    <div className="space-y-8">
                        {steps.map((step, index) => (
                            <PaymentStep
                                key={index}
                                step={index + 1}
                                title={step.title}
                                description={step.description}
                                icon={step.icon}
                                isLast={index === steps.length - 1}
                            />
                        ))}
                    </div>
                     <p className="mb-4 leading-relaxed">
          Für Bitcoin- und USDC-Zahlungen arbeiten wir mit unserem erfahrenen und vollständig regulierten Partner abpay aus Liechtenstein zusammen. abpay ermöglicht eine einfache, sichere und schnelle Abwicklung von Krypto-Zahlungen und stellt dabei stets aktuelle Wechselkurse zur Verfügung. Weitere Informationen finden Sie unter: <a href="https://www.abpay.net" target="_blank" rel="noopener noreferrer" className='text-blue-400 underline'>www.abpay.net</a>            </p>
                </div>
                
            </div>
        </div>
    )
}
